﻿import 'react-native-get-random-values';
import './src/shared/dev/installWebConsoleFilters';
import './src/shared/dev/installWebChunkReloadGuard';
import './src/shared/dev/installWebPilotEnvironment';

// Polyfill crypto.randomUUID para React Native (solo getRandomValues viene con el paquete)
// Asegurar que global.crypto siempre exista antes de agregar randomUUID.
if (typeof (global as any).crypto === 'undefined') {
  (global as any).crypto = {
    getRandomValues: (arr: Uint8Array) => {
      // react-native-get-random-values ya definió getRandomValues en global,
      // pero si global.crypto no existía, lo exponemos acá como wrapper.
      const { getRandomValues: nativeGetRandomValues } = require('react-native-get-random-values');
      return nativeGetRandomValues(arr);
    },
  };
}
if (typeof (global as any).crypto.randomUUID !== 'function') {
  (global as any).crypto.randomUUID = function (): string {
    const bytes = new Uint8Array(16);
    (global as any).crypto.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
    bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 10
    const h = Array.from(bytes, (b) => b.toString(16).padStart(2, '0'));
    return `${h[0]}${h[1]}${h[2]}${h[3]}-${h[4]}${h[5]}-${h[6]}${h[7]}-${h[8]}${h[9]}-${h[10]}${h[11]}${h[12]}${h[13]}${h[14]}${h[15]}`;
  };
}

import { registerRootComponent } from 'expo';
import { Asset } from 'expo-asset';
import { Platform } from 'react-native';

import { installTextDecoderLatin1 } from './src/shared/polyfills/installTextDecoderLatin1';
import App from './App';
import { VUELTO_V_MARK, getVueltoVMarkUri } from './bootSplashAssets';
import { silenceConsoleInProduction } from './src/shared/dev/devLog';

// Después de `expo` (TextDecoder utf-8-only) y antes de App (jspdf vía shell).
installTextDecoderLatin1();
silenceConsoleInProduction();

/** Evita que el logo del boot aparezca "un tick" después: decode en web y Asset en nativo antes del primer paint. */
async function preloadBootSplashLogo(): Promise<void> {
  try {
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
      const uri = getVueltoVMarkUri();
      if (!uri) return;
      await new Promise<void>((resolve) => {
        const img = new window.Image();
        img.onload = () => resolve();
        img.onerror = () => resolve();
        img.src = uri;
      });
      return;
    }
    await Asset.loadAsync(VUELTO_V_MARK);
  } catch {
    /* no bloquear arranque */
  }
}

const BOOT_LOGO_PRELOAD_BUDGET_MS = 500;

// Registrar de inmediato: si se difiere, Android dev puede montar "main" antes y muestra "App entry not found".
registerRootComponent(App);

void Promise.race([
  preloadBootSplashLogo(),
  new Promise<void>((resolve) => setTimeout(resolve, BOOT_LOGO_PRELOAD_BUDGET_MS)),
]);
